module.exports = __webpack_public_path__ + "fonts/NanumSquareRoundR.ca200c8.woff2";